import React from 'react';
import { radiansToDegrees, reverseDegrees } from '../..';
export var ReverseRotate = function (_a) {
    var _b = _a.rotateY, rotateY = _b === void 0 ? 0 : _b, _c = _a.rotateX, rotateX = _c === void 0 ? 0 : _c, angle = _a.angle, children = _a.children;
    return (React.createElement("g", { transform: reverseRotateTransform(rotateX, rotateY, angle) }, children));
};
export var reverseRotateTransform = function (x, y, angle) {
    var degrees = reverseDegrees(radiansToDegrees(angle));
    return degrees % 360 ? "rotate(".concat(degrees, " ").concat(x, " ").concat(y, ")") : '';
};
//# sourceMappingURL=reverse-rotate.js.map